import __ from "src/utils/Translations";
import { ErrorCode } from "src/Pages/Company/OrganizationStructure/utils/errors/errorCode";

export const getErrorMessages = () => ({
  [ErrorCode.VALIDATION_ERROR]: () => __("Błąd walidacji danych"),
  [ErrorCode.NAME_TAKEN]: () =>
    __("W strukturze istnieje już obszar z podaną nazwą."),
  [ErrorCode.INVALID_PARENT]: () =>
    __("W strukturze istnieje już obszar z podaną nazwą."),
  [ErrorCode.INVALID_ADDITIONAL_DISPLAY_AREA]: () =>
    __(
      "Przekazany obszar jest niepoprawny, np. jest nieaktywny, nie istnieje."
    ),
  [ErrorCode.INVALID_MANAGER]: () =>
    __(
      "Przekazany obszar jest niepoprawny, np. jest nieaktywny, nie istnieje."
    ),
  [ErrorCode.INVALID_MEMBER]: () =>
    __(
      "Przekazany obszar jest niepoprawny, np. jest nieaktywny, nie istnieje."
    ),
  [ErrorCode.MEMBER_CANNOT_BE_SUBORDINATE_OF_MANAGER]: (field?: string) => {
    if (field?.startsWith("members")) {
      return __(
        "Członek nie może być podwładnym managera obszaru - sytuacja, gdy członek powinien dziedziczyć przełożonego z obszaru, ale jest jego przodkiem."
      );
    }
    if (field === "manager") {
      return __(
        "Manager nie może być podwładnym managera obszaru nadrzędnego - gdy manager należy do obszaru, którym zarządza i ma zaznaczone dziedziczenie przełożonego, powinien odziedziczyć przełożonego z pierwszego obszaru nadrzędnego, który ma innego przełożonego."
      );
    }
    return __("Wystąpił nieznany błąd.");
  },
  [ErrorCode.MANAGER_CANNOT_BE_INHERITED]: () =>
    __(
      "Manager nie może być odziedziczony jako przełożony przez managerów podrzędnych obszarów."
    ),
});
